module.exports = __webpack_public_path__ + "static/img/COC2023-11.1ab3d6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-11.png
// module id = sFU2
// module chunks = 0